import * as React from 'react';

import { EvenButton } from '../../_atomics/Button/EvenButton';

import styles from './UpgradeBanner.module.scss';

export interface UpgradeBannerProps {
  monthlyFee?: number;
  onClick: () => void;
}

export const UpgradeBanner: React.FC<UpgradeBannerProps> = ({
  monthlyFee,
  onClick,
}) => {
  return (
    <>
      {monthlyFee !== 0 && (
        <div className={styles['upgrade-banner']}>
          <p className={styles['upgrade-banner-text']}>
            Purchase a plan to continue using your integrations before trial
            period expires.
          </p>
          <EvenButton onClick={onClick}>Purchase Plan</EvenButton>
        </div>
      )}
    </>
  );
};
